import React from 'react'
import { arrayOf, number, shape, string } from 'prop-types'
import { useUser } from '@fs/zion-user'
import { css } from '@emotion/core'
import { useAtSize } from '@fs/zion-ui'
import GlobalNameCounts from './GlobalNameCounts'
import ComparisonPanel from '../ComparisonPanel/ComparisonPanel'
import { useDSCState } from '../../../../../state/DSCStore'
import { useAamState } from '../../../state/AamStore'
import { getGender } from '../../../../../shared/helpers/person_Helper'
import { useComparisonByName } from '../../../hooks/hooks'

export default function GlobalNameCountsComparison({
  parsedNames,
  comparisonParsedNames,
  comparisonTargetPerson,
  tileData,
  tileComparisonContent,
  tileContentData,
}) {
  const user = useUser()
  const atSize = useAtSize()
  const dscState = useDSCState()
  const aamState = useAamState()
  const showComparison = useComparisonByName(
    aamState,
    comparisonTargetPerson,
    dscState,
    tileData,
    parsedNames,
    comparisonParsedNames
  )

  const containerStyle = css`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    flex-direction: ${atSize({ default: 'column-reverse', md: 'row' })};
  `
  const background =
    comparisonTargetPerson?.gender && comparisonTargetPerson?.personId !== user.personId ? 'SOLID' : 'NONE' // Don't show a background if there isn't a comparisonTarget, or the comparisonTarget is the user

  return (
    <>
      <div css={containerStyle}>
        <ComparisonPanel gender={tileData?.gender?.toLowerCase()} background={background}>
          <GlobalNameCounts tileData={tileContentData} />
        </ComparisonPanel>
        {showComparison && (
          <>
            <ComparisonPanel
              gender={
                comparisonTargetPerson?.gender
                  ? comparisonTargetPerson?.gender.toLowerCase()
                  : getGender(comparisonTargetPerson?.genderType)
              }
              background="SOLID"
            >
              <GlobalNameCounts tileData={tileComparisonContent} />
            </ComparisonPanel>
          </>
        )}
      </div>
    </>
  )
}

GlobalNameCountsComparison.propTypes = {
  parsedNames: shape({
    firstName: shape({}),
    lastName: shape({}),
    middleNames: arrayOf(
      shape({
        name: string,
      })
    ),
  }),
  tileContentData: shape({
    category: string,
    categoryId: number,
    icon: string,
    id: number,
    languageOnly: string,
    localeOnly: string,
    price: number,
    subcategory: string,
    textHeadline: string,
    textTitle: string,
    tileType: string,
    year: number,
  }),
  tileData: shape({
    personId: string,
    gender: string,
  }),
}
